import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'food_and_beverage-pdp_product_info_section_expandable-click';

/**
 * When the user toggles the expansion state of a section of the product information on the Product Details Page
 */
export function trackFoodAndBeveragePdpProductInfoSectionExpandableClick(
  Section_Type_string: string,
  Expand_or_Collapse_string2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Section_Type_string, Expand_or_Collapse_string2 },
  });
}
